import React from "react";

import RevealBlock from "components/site/RevealBlock";
import SiteAction from "components/site/SiteAction";
import { Container } from "components/site/SitePrimitives";
import SiteShell from "components/site/SiteShell";
import usePageMeta from "hooks/usePageMeta";

function Error404() {
  usePageMeta({
    title: "Not Found | Ignitum Solutions",
    description: "The requested page could not be found.",
    path: "/error-404",
    robots: "noindex,nofollow",
  });

  return (
    <SiteShell pageClassName="ignitum-site-page ignitum-error-page">
      <section className="site-not-found">
        <Container>
          <RevealBlock variant="card">
            <div className="site-card site-highlight">
              <p className="site-not-found-code">404</p>
              <h1>Page not found</h1>
              <p className="site-hero-description">
                The page you requested does not exist or is no longer part of the
                current public site.
              </p>
              <div className="site-page-actions">
                <SiteAction className="site-btn site-btn-primary" to="/">
                  Return home
                </SiteAction>
                <SiteAction className="site-btn site-btn-secondary" to="/approach">
                  View approach
                </SiteAction>
              </div>
            </div>
          </RevealBlock>
        </Container>
      </section>
    </SiteShell>
  );
}

export default Error404;
